// extracted by mini-css-extract-plugin
module.exports = {"tabs":"styles_tabs__36Nzh","hidden":"styles_hidden__wKXjE"};